var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{staticClass:"custom-link",attrs:{"href":_vm.file.link,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.file.filename)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }